import { useEffect, useState } from 'react';
import { lunchMenu } from '../data/menuData';

let cached = null;

// Admin-saved weekly menu from the API, falling back to the bundled menuData
export const useDailyMenus = () => {
  const [menus, setMenus] = useState(cached || lunchMenu.dailyMenus);
  useEffect(() => {
    let alive = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/lunch-menu`)
      .then((r) => r.json())
      .then((d) => {
        if (alive && d.dailyMenus) { cached = d.dailyMenus; setMenus(d.dailyMenus); }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return menus;
};
